// Fallback removal delay used when `transitionend` never fires (e.g.
// prefers-reduced-motion or a zero-duration transition). Kept slightly above
// the 200ms opacity transition on #app-shell (see index.html) plus a buffer.
const APP_SHELL_FADE_FALLBACK_MS = 350;

// Backstop so the overlay can never trap the user if no route ever mounts.
export const APP_SHELL_SAFETY_NET_MS = 6000;

let safetyNetTimerId: ReturnType<typeof setTimeout> | undefined;

export function removeAppShell(): void {
  if (safetyNetTimerId !== undefined) {
    clearTimeout(safetyNetTimerId);
    safetyNetTimerId = undefined;
  }
  const el = document.getElementById('app-shell');
  if (!el) {
    return;
  }
  el.classList.add('app-shell--hidden');
  const remove = () => el.remove();
  const timeoutId = setTimeout(remove, APP_SHELL_FADE_FALLBACK_MS);
  el.addEventListener(
    'transitionend',
    () => {
      clearTimeout(timeoutId);
      remove();
    },
    { once: true },
  );
}

export function scheduleAppShellSafetyNet(
  ms: number = APP_SHELL_SAFETY_NET_MS,
): void {
  safetyNetTimerId = setTimeout(removeAppShell, ms);
}
